module.exports = __webpack_public_path__ + "static/image23-42d501eea809f24addea3808976cc9e9.jpg";